module.exports = __webpack_public_path__ + "static/media/242 Park - Exterior Draft 4.79f226c7.jpg";